module.exports = __webpack_public_path__ + "img/progress_052.4a27adf5.png";